import { Platform, Pressable } from 'react-native'
import { useTranslation } from 'react-i18next'
import useAnimatedPress from '@ui/animated/useAnimatedPress'
import TileBlur from '@ui/tiles/TileBlur'
import Button from '@ui/buttons/Button'
import { PackageType as GlassesType } from '@ca/common/types'
import cn from '@ui/utils/cn'
import Gradient from '@ui/effects/Gradient'
import { colors } from '@ui/colors'
import { borderRadius } from '@ui/theme/values'

interface Props {
  type: GlassesType
  disabled?: boolean
  onPress?: () => void
}

const image: Record<GlassesType, string> = {
  sv: require('@/images/strategy/sv.png'),
  vf: require('@/images/strategy/vf.png'),
  office: require('@/images/strategy/office.png'),
}

export default function GlassesTypeItem({ type, onPress, disabled }: Props) {
  const { animation, onPressIn, onPressOut } = useAnimatedPress()
  const { t } = useTranslation(['configuration'])
  const text = `configuration:glassestype.sections.${type}`

  return (
    <>
      <Pressable
        onPress={onPress}
        onPressIn={onPressIn}
        onPressOut={onPressOut}
        className="flex-1"
        disabled={disabled}
      >
        <TileBlur
          variant="option"
          title={t(`${text}.title`)}
          desc={t(`${text}.desc`)}
          cta={
            <Button
              noninteractive
              animation={animation}
              onPress={onPress}
              size="sm"
              variant="outlined"
              label={t('ui:select')}
              disabled={disabled}
            />
          }
          glassProps={{
            animation,
            image: image[type],
            imageStyle: {
              opacity: disabled ? 0.25 : 1,
              transformOrigin: 'right',
              transform: [
                { translateX: Platform.select({ default: -25, web: -50 }) },
                { translateY: 0 },
              ],
            },
            blur: Platform.select({ default: 100, web: 50 }),
            blurStyle: {
              opacity: Platform.select({ default: 0.5, web: 0.75 }),
              transformOrigin: 'center',
              transform: [
                { translateX: 0 },
                { translateY: 50 },
                { scale: 0.75 },
              ],
            },
            gradient: disabled && (
              <Gradient
                colors={[colors.white, colors.white]}
                style={{ borderRadius }}
              />
            ),
            className: 'overflow-hidden-fixer',
          }}
          classNameTitle={cn(disabled && 'color-neutral-300')}
          classNameDesc={cn(disabled && 'color-neutral-300')}
        />
      </Pressable>
    </>
  )
}
